import RenderLabel from 'components/language/RenderLabel'

import Button from '../common/Button'
import { Step } from '../types'

interface WizardFooterProps {
  handleNext: () => void
  handlePrev: () => void
  handleSubmit: () => void
  isStepValid: boolean
  step: number
  steps: Step[]
  submitLabel: string
  disabled?: boolean
}

const WizardFooter = ({
  handleNext,
  handlePrev,
  handleSubmit,
  isStepValid,
  step,
  steps,
  submitLabel,
  disabled,
}: WizardFooterProps) => {
  return (
    <div className="w-full h-20 mt-1 border-t flex-shrink-0 flex items-center justify-center">
      <Button onClick={handlePrev} disabled={step === 0 || disabled}>
        <RenderLabel>prev</RenderLabel>
      </Button>
      {step === steps.length - 1 && submitLabel ? (
        <Button onClick={handleSubmit} disabled={!isStepValid || disabled}>
          {submitLabel}
        </Button>
      ) : (
        <Button onClick={handleNext} disabled={!isStepValid || disabled}>
          <RenderLabel>next</RenderLabel>
        </Button>
      )}
    </div>
  )
}

export default WizardFooter
